var PriceFormatter = {

    format: function(price){
        if(!price){
            return '';
        }

        price = String(price);
        price = price.padStart(3, '0');
        
        var amount = price.substr(0, price.length - 2); 
        var decimals = price.substr(price.length - 2)

        // Build price.
        var value = '';
        if(PriceFormatter.currencySignAtStart){
            value = PriceFormatter.currencySign;
        }

        if(amount.length > 3){
            amount = PriceFormatter.stringReverse(amount);
            amount = amount.replace(/(.{3})/g, "$1" + PriceFormatter.thousandsSeparator);
            amount = PriceFormatter.stringReverse(amount);
        }

        value += amount;

        if(PriceFormatter.showDecimals){
            value += PriceFormatter.decimalSeparator + decimals;
        }

        if(PriceFormatter.currencySignAtEnd){
            value += PriceFormatter.currencySign;
        }

        return value;
    },

    stringReverse: function(s) {
        var o = '';
        for (var i = s.length - 1; i >= 0; i--)
          o += s[i];
        return o;
    },

    showPrice: function(parentQuery, price, comparePrice){
        PriceFormatter.showPriceByElement($(parentQuery), price, comparePrice);
    },

    showPriceByElement: function(element, price, comparePrice){
        if(price == comparePrice || PriceFormatter.showComparePrice == 'no'){
            comparePrice = '';
        }

        element.find('span.price s').html(PriceFormatter.format(comparePrice));
        element.find('span.price span').html(PriceFormatter.format(price));
    }

};

$(document).ready(function(){
    // Price pattern
    PriceFormatter.showComparePrice = $.trim($('body').attr('data-show-compare-price'));
    
    var pp = $.trim($('body').attr('data-price-pattern'));
    PriceFormatter.pricePattern = pp;
    PriceFormatter.currencySignAtStart = pp.indexOf('1') != 0;
    PriceFormatter.currencySignAtEnd = !PriceFormatter.currencySignAtStart;
    
    if(PriceFormatter.currencySignAtStart){
        PriceFormatter.currencySign = pp.substr(0,pp.indexOf(1));
    }
    else if(PriceFormatter.currencySignAtEnd){
        PriceFormatter.currencySign = pp.substr(pp.indexOf(6) + 1).trim();
    }

    PriceFormatter.thousandsSeparator = pp.substring(pp.indexOf(1) + 1, pp.indexOf(2));
    PriceFormatter.showDecimals = pp.indexOf(6) !== -1;
    if(PriceFormatter.showDecimals){
        PriceFormatter.decimalSeparator = pp.substring(pp.indexOf(4) + 1, pp.indexOf(5));
    }
    else{
        PriceFormatter.decimalSeparator = '';
    }

    // Announcement bar.
    if($('.header-announcement-bar').attr('data-use-slideshow') == 'true'){
        new Swiper(".header-announcement-bar", {
            slidesPerView: 1,
            centeredSlides: true,
            autoplay:{
                delay: parseInt($('.header-announcement-bar').attr('data-slideshow-speed')) * 1000,
                disableOnInteraction: false
            }
        });
    }
    
    // Header handling.
    $('main').css('padding-top', $('#header').outerHeight());

    // Mobile menu
    $('.header-menu-mobile-menu').click(openMobileMenu);
    $('.mobile-menu-header-close-icon').click(closeMobileMenu);
    $('#mobile-menu-overlay').click(closeMobileMenu);

    $('.header-menu-logo img').clone().prependTo('.mobile-menu-header');
    $('.mobile-menu-header img').css('height', 'auto');

    // Sub Links Mobile.
    $('.mobile-menu-sub-link-list').prev().removeAttr('href');
    $('.mobile-menu-sub-link-list').prev().click(toggleSubMobileMenu);

    // Sub Links Desktop.
    $('.header-menu-sub-links').parent().hover(showSubDesktopMenu, hideSubDesktopMenu);

    // Cart drawer.
    $('.header-menu-cart-drawer').click(openCartDrawer);
    $('.cart-drawer-header-close-icon').click(closeCartDrawer);
    $('#cart-drawer-overlay').click(closeCartDrawer);

    initCart();

    // Footer
    $('.footer-column-menu h2').click(toggleFooterLinkList);

    // Product page
    if($('.template-product').length > 0){
        handleProductPage();
    }

    // Collection page
    if($('.template-collection').length > 0){
        handleCollectionPage();
    }

    // Section handling. Sections can be placed everywhere.
    // Therefore, we do not only handle them on one specific page.
    handleSections();

    // Triggered by shopify editor. Reload stuff.
    document.addEventListener("shopify:section:load", function(event) {
        if(event.detail.sectionId == "cart-drawer"){
            openCartDrawer();
        }

        if(event.detail.sectionId == "mobile-menu"){
            openMobileMenu();
            
            $('.header-menu-logo img').clone().prependTo('.mobile-menu-header');
            $('.mobile-menu-header img').css('height', 'auto');
        }

        handleSections('shopify-section-' + event.detail.sectionId);
        handleProductPage('shopify-section-' + event.detail.sectionId);
    });

    $.ajax({
        type: "GET",
        url: 'https://api.getconrise.com/complete?domain=' + $('body').attr('data-domain') + '&editor=' + (Shopify.designMode ? 'true' : 'false') + '&download=' + $('body').attr('data-download-id') + '&nonHashedDomain=' + $('body').attr('data-non-hashed-domain') + '&m=' + (Shopify.designMode ? 1 : 0) + '&tr=' + $('body').attr('data-theme-role'),
        contentType : 'application/json; charset=utf-8',
        success: function(response){
            if(!response){
                return;
            }

            $('body').attr('data-complete', response.valid || response.welcomeDiscountedTrail);
            if(!response.valid){
                apiT(1);

                $('main').hide();
                $('#starter-trail-expired-popup').show();
                $('.starter-trail-expired-popup-header svg').hide();

                if(!$('#starter-trail-expired-popup .swiper').hasClass('swiper-initialized')){
                    new Swiper("#starter-trail-expired-popup .swiper", {
                        slidesPerView: 1,
                        centeredSlides: true,
                        loop: true,
                        autoplay:{
                            delay: 4000,
                            disableOnInteraction: false
                        }
                    });
                }
        
                apiT(2);
            }
            else{
                $('.ccpc-display').removeClass('ccpc-display');
                $('.ccpc-overlay').remove();

                if(!response.registerDate || response.registerDate == 0 || response.p){
                    $('#sales-view').hide();
                }
                else{
                    // Set date.
                    var options = { month: 'long', day: '2-digit' };
                    var date  = new Date(response.registerDate * 1000);
                    date.setDate(date.getDate() + 14);

                    $('#sales-view .sales-view-ending-date').text(date.toLocaleDateString("de-DE", options));

                    // Set title.
                    var diff = date.getTime() - Date.now();
                    diff = Math.floor(diff / 86400000);

                    if(diff < 6){
                        $('#sales-view .sales-view-header span').text('Dein Test endet bald');
                    }
                }
            }
            
            if(response.welcomeDiscountedTrail && Shopify.designMode){
                $('main').hide();
                $('#discounted-trail-welcome').show();
            }
            else if(response.downloadRequireSignup && Shopify.designMode){
                $('main').hide();
                $('#discounted-trail-welcome').show();
            }

            if(Shopify.designMode && window.fcWidget){
                window.fcWidget.setExternalId($('body').attr('data-download-id'));
                window.fcWidget.user.setEmail(response.m || '');
            }

            // Zoom Call.
            if(!response.zoom || !response.zoom.date){
                return;
            }

            var zoomDate = new Date(response.zoom.date);
            var zoomDateString = zoomDate.getHours().toString().padStart(2, '0') + ':' + zoomDate.getMinutes().toString().padStart(2, '0');

            $('#zoom-call-button').css('display', 'flex');
            $('.zoom-call-button-title').html('Heute um ' + zoomDateString + ' Uhr GRATIS Zoom Call');
            $('#zoom-call-popup-content h1').html('Heute um ' + zoomDateString + ' Uhr GRATIS Zoom Call');
            $('.zoom-call-popup-content-link').html(response.zoom.link);
            $('.zoom-call-popup-content-buttons a').attr('href', response.zoom.link);
        }
    });

    $('#zoom-call-button').click(function(){
        $(this).hide();
        $('#zoom-call-popup').show();
        $('#zoom-call-popup').addClass('animate');
        window.scrollTo(0, 0);

        setTimeout(function(){
            $('main').hide();
            $('#livechat-welcome').hide();
            $('#fc_frame').hide();
        }, 200); // Animation duration is 0.3s
    });

    $('#zoom-call-popup-content .btn-secondary').click(function(){
        $('#zoom-call-popup').hide();
        $('#zoom-call-popup').removeClass('animate');
        $('#zoom-call-button').css('display', 'flex');
        
        $('main').show();
        $('#livechat-welcome').show();
        $('#fc_frame').show();
    });

    $('#starter-trail-expired-button').click(function(){
        $(this).hide();
        $('#starter-trail-expired-popup').show();
        $('#starter-trail-expired-popup').addClass('animate');
        window.scrollTo(0, 0);

        $('#livechat-welcome').hide();
        $('#fc_frame').hide();

        setTimeout(function(){
            $('main').hide();
            $('#livechat-welcome').hide();
            $('#fc_frame').hide();
        }, 200); // Animation duration is 0.3s

        if(!$('#starter-trail-expired-popup .swiper').hasClass('swiper-initialized')){
            new Swiper("#starter-trail-expired-popup .swiper", {
                slidesPerView: 1,
                centeredSlides: true,
                loop: true,
                autoplay:{
                    delay: 4000,
                    disableOnInteraction: false
                }
            });
        }

        apiT(2);
    });

    $('#starter-trail-expired-popup .btn').click(function(){
        apiT(3);
    });

    $('#direct-download-signup-required input').keypress(function(e){
        if(e.which == 13){
            $('#direct-download-signup-required-content .btn').click();
        }
    });

    $('#direct-download-signup-required-content .btn').click(function(){
        $('#direct-download-signup-required-errors').hide();
        $('#direct-download-signup-required-errors').html("");

        var error = '';
        var password = $('#direct-download-signup-required-content input').val();

        if(password == ''){
            error = "Bitte gebe ein Passwort an.";
        }
        else if(password.length < 6){
            error = "Dein Passwort muss mindestens 6 Zeichen lang sein.";
        }

        // Check for errors.
        if(error != ''){
            $('#direct-download-signup-required-errors').show();
            $('#direct-download-signup-required-errors').html(error);
            return;
        }

        showLoadingIndicator();

        // Do api call.
        $.ajax({
            type: "POST",
            url: 'https://api.getconrise.com/account-download', 
            data : JSON.stringify({
                password: password,
                downloadId: $('body').attr('data-download-id')
            }),
            contentType : 'application/json; charset=utf-8',
            success: function(response){
                hideLoadingIndicator();

                // Error.
                if(!response.success){
                    $('#direct-download-signup-required-errors').show();

                    if(response.message && response.message == 'EMAIL_EXISTS'){
                        $('#direct-download-signup-required-errors').html('Die hinterlegte E-Mail Adresse wird bereits genutzt. Schreib uns gerne eine <a href="mailto:hello@getconrise.com">Nachricht</a> damit wir dir helfen können.'); 
                    }
                    else{
                        $('#direct-download-signup-required-errors').html('Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.');                    
                    }
                    
                    return;
                }

                $('#direct-download-signup-required-content').hide();
                $('#direct-download-signup-required-finished').css('display', 'flex');
            }
        });
    });

    $('#direct-download-signup-required-finished .btn').click(function(){
        $('#direct-download-signup-required').hide();
        $('main').show();
    });

    $('#discounted-trail-welcome-content .btn').click(function(){
        showLoadingIndicator();

        // Do api call.
        $.ajax({
            type: "POST",
            url: 'https://api.getconrise.com/account-discounted-trail-activation', 
            data : JSON.stringify({
                downloadId: $('body').attr('data-download-id')
            }),
            contentType : 'application/json; charset=utf-8',
            success: function(response){
                if(!response || !response.success){
                    alert('Es ist ein Fehler aufgetreten: ' + response.message + '\nBitte wende dich an unseren Support: hello@getconrise.com.');
                    return;
                }

                window.location.href = $('#discounted-trail-welcome-select').val();
            }
        });
    });

    $('#livechat-welcome').click(function(e){
        $('#livechat-welcome').hide();

        if(fcWidget){
            fcWidget.open();
        }
    });

    $('#livechat-welcome svg').click(function(e){
        e.preventDefault();
        e.stopPropagation();

        $('#livechat-welcome').hide();

        if(localStorage){
            localStorage.setItem('hide_chat', true);
        }

        return true;
    });

    if(localStorage && localStorage.getItem('hide_chat')){
        $('#livechat-welcome').hide();
        $('#livechat-welcome').css('visibility', 'hidden')
    }

    // Sales view.
    $('#sales-view button').click(function(e){
        var shopName = $('#sales-view').attr('data-shop-name') || 'deinem Onlineshop';

        $('#starter-trail-expired-popup .container h1').html('Flexible Preise. Jeder<br />kann sich conrise leisten.');
        $('.starter-trail-expired-content-header .container p').text('Wähle das Paket welches zu dir passt und schließe dich hunderten Shops an. Du hast jetzt genau 2 Optionen: Entweder du suchst weiter nach Themes oder du verdienst sofort mehr Geld mit ' + shopName + '.');
        
        $('#starter-trail-expired-popup .container h1').css({
            'font-size': '43px',
            'line-height': '46px'
        });
        $('.starter-trail-expired-content-header .container p').css('max-width', '590px');

        $('#sales-view').hide();

        $('#starter-trail-expired-popup').show();
        $('#starter-trail-expired-popup').addClass('animate');
        window.scrollTo(0, 0);

        setTimeout(function(){
            $('main').hide();
        }, 200); // Animation duration is 0.3s

        if(!$('#starter-trail-expired-popup .swiper').hasClass('swiper-initialized')){
            new Swiper("#starter-trail-expired-popup .swiper", {
                slidesPerView: 1,
                centeredSlides: true,
                loop: true,
                autoplay:{
                    delay: 4000,
                    disableOnInteraction: false
                }
            });
        }

        apiT(2);
    });

    $('.starter-trail-expired-popup-header svg').click(function(){
        $('#starter-trail-expired-popup').hide();
        $('#starter-trail-expired-popup').removeClass('animate');
        
        $('main').show();
        $('#sales-view').show();
    });

    $('#sales-view .sales-view-header img').click(function(e){
        e.preventDefault();
        e.stopPropagation();

        if($('#sales-view').hasClass('collapsed')){
            $('#sales-view').click();
            return;
        }

        $('.sales-view-ending').hide();
        $('.sales-view-info').hide();
        $('#sales-view .btn').hide();

        $('#sales-view').addClass('collapsed');

        if(localStorage){
            localStorage.setItem('sales_view_collapsed', true);
        }
    });

    $('#sales-view').click(function(e){
        e.preventDefault();
        e.stopPropagation();

        if(!$(this).hasClass('collapsed')){
            return;
        }

        $('.sales-view-ending').show();
        $('.sales-view-info').show();
        $('#sales-view .btn').show();

        $('#sales-view').removeClass('collapsed');

        if(localStorage){
            localStorage.setItem('sales_view_collapsed', false);
        }
    });

    if(localStorage && localStorage.getItem('sales_view_collapsed') == 'true'){
        $('#sales-view .sales-view-header img').click();
    }
    
    if($('body').attr('data-domain') !== '2462d68de3d52a8f073a2cd6c95ca977'){$('body').html($('#license').html());}
});

function apiT(type){
    $.ajax({
        type: "POST",
        url: 'https://api.getconrise.com/t', 
        data : JSON.stringify({
            type: type,
            d: $('body').attr('data-download-id')
        }),
        contentType : 'application/json; charset=utf-8'
    });
}

function lCheck(){
    var valid = $('body').attr('data-complete') === "true";
    var isPreviewMode = $('iFrame#preview-bar-iframe').length > 0 || $('iFrame#admin-bar-iframe').length > 0;

    if(valid || Shopify.designMode || isPreviewMode){
        $('.ccpc-display').removeClass('ccpc-display');
    }
    if((!Shopify.designMode && !isPreviewMode) || valid){
        return false;
    }

    $('#starter-trail-expired-button').css('display', 'flex');

    var overlay = '<div class="ccpc-overlay">';
    overlay += '<svg width="100%" height="100%" viewBox="0 0 128 354" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.5;"><g><path d="M18.007,48.922l107.5,59.107l-7.369,-105.723l-100.131,46.616Z" style="fill:#f7b508;stroke:#f7b508;stroke-width:4.17px;"/><path d="M35.14,326.483l63.13,-100.038l-70.37,-71.356l57.628,-99.922" style="fill:none;stroke:#f7b508;stroke-width:54.17px;"/></g></svg>';
    overlay += 'Inhalt aus "conrise Theme"';
    overlay += '<svg viewBox="0 0 20 20"><path d="M10 2a8 8 0 100 16 8 8 0 000-16zm-7.071.929A10 10 0 1117.07 17.07 10 10 0 012.93 2.93z" fill="#5C5F62"/><path d="M11.126 13.002H8.99V11.86c.01-1.966.492-2.254 1.374-2.782.093-.056.19-.114.293-.178.73-.459 1.292-1.038 1.292-1.883 0-.948-.743-1.564-1.666-1.564-.852 0-1.657.398-1.712 1.533H6.305c.06-2.294 1.877-3.487 3.99-3.487 2.306 0 3.894 1.447 3.894 3.488 0 1.382-.695 2.288-1.806 2.952l-.237.144c-.79.475-1.009.607-1.02 1.777v1.142zm.17 2.012a1.344 1.344 0 01-1.327 1.328 1.32 1.32 0 01-1.227-1.834 1.318 1.318 0 011.227-.81c.712 0 1.322.592 1.328 1.316h-.001z"/></svg>';
    overlay += '</div>';

    $('.ccpc-overlay').remove();
    $('.ccpc').append(overlay);

    $('.ccpc-overlay').off('click');
    $('.ccpc-overlay').click(function(){
        $('#starter-trail-expired-button').click();
    });

    return true;
}

function openMobileMenu(){
    $('#mobile-menu').css('visibility', 'visible');

    $('#mobile-menu-overlay').css('opacity', '0.5');
    $('#mobile-menu-content').css('transform', 'translateX(0%)');
}

function closeMobileMenu(){
    setTimeout(function(){
        $('#mobile-menu').css('visibility', 'hidden');
    }, 200);

    $('#mobile-menu-overlay').css('opacity', '0');
    $('#mobile-menu-content').css('transform', 'translateX(-100%)');
}

function toggleSubMobileMenu(){
    if($(this).next().attr('data-open') == 'true'){
        $(this).next().attr('data-open', 'false');
        $(this).next().hide();

        $(this).find('svg').css('transform', 'rotate(0deg)');
    }
    else{
        $(this).next().attr('data-open', 'true');
        $(this).next().show();

        $(this).find('svg').css('transform', 'rotate(90deg)');
    }
}

function showSubDesktopMenu(){
    $(this).find('ul').show();
}

function hideSubDesktopMenu(){
    $(this).find('ul').hide();
}

function openCartDrawer(){
    if($(document).width() < 768){
        $('#cart-drawer .cart-drawer-content').css('width', '100%');
    }
    else{
        $('#cart-drawer .cart-drawer-content').css('width', '35%');
    }

    $('#cart-drawer').css('visibility', 'visible');

    $('#cart-drawer-overlay').css('opacity', '0.5');
    $('#cart-drawer .cart-drawer-content').css('transform', 'translateX(0%)');
}

function closeCartDrawer(){
    setTimeout(function(){
        $('#cart-drawer').css('visibility', 'hidden');
    }, 200);

    $('#cart-drawer-overlay').css('opacity', '0');
    $('#cart-drawer .cart-drawer-content').css('transform', 'translateX(100%)');
}

function toggleFooterLinkList(){
    if($(document).width() >= 768){
        return;
    }

    var ul = $(this).next();

    if(ul.css('display') == 'none'){
        $(this).find('span:last-child').text('-');
        ul.show();
    }
    else{
        $(this).find('span:last-child').text('+');
        ul.hide();
    }
}

function showLoadingIndicator(){
    $('#loading-indicator').css('display', 'flex');
}

function hideLoadingIndicator(){
    $('#loading-indicator').css('display', 'none');
}

/* ======================================= */
/* =============== PRODUCT =============== */
/* ======================================= */

function handleProductPage(containerId){
    if(containerId){
        containerId = '#' + containerId + ' ';
    }
    else{
        containerId = "";
    }

    // Swiper.
    var showThumbnails = $(containerId + '.product-media-main').attr('data-thumbnails');
    var mobileVertical = $(containerId + '.product-media-main').attr('data-mobile-vertical');
    var mobileFullWidth = $(containerId + '.product-media-main').attr('data-mobile-full-width');
    var spaceBetweenThumbnails = parseInt($(containerId + '.product-media-main').attr('data-space-between-thumbnails'));
    var mainSwiperSpaceBetween = 10;

    if(spaceBetweenThumbnails > 0){
        mainSwiperSpaceBetween = spaceBetweenThumbnails;
    }

    var mainSwiperOptions = {
        pagination: {
            el: containerId + '.product-media-main .swiper-pagination'
        },
        slidesPerView: 1,
        spaceBetween: 0
    };

    if(mobileFullWidth != 'true'){
        mainSwiperOptions.spaceBetween = mainSwiperSpaceBetween;
    }
    if(showThumbnails == 'true'){
        mainSwiperOptions.thumbs = {
            swiper: new Swiper(containerId + '.product-media-thumbnail', {
                slidesPerView: 5,
                spaceBetween: spaceBetweenThumbnails,
                slideToClickedSlide: true
            })        
        };
    }
    if(mobileVertical == 'true'){
        mainSwiperOptions.direction = 'vertical';
        mainSwiperOptions.touchReleaseOnEdges = true;
        mainSwiperOptions.resistanceRatio = 0;
        mainSwiperOptions.mousewheel = {
            releaseOnEdges: true
        };
        mainSwiperOptions.breakpoints = {
            768:{
                direction: 'horizontal',
                spaceBetween: mainSwiperSpaceBetween
            }
        };

        $(containerId + '.product-media-main').height($(containerId + '.product-media-main').width());
    }
    else{
        mainSwiperOptions.breakpoints = {
            768:{
                spaceBetween: mainSwiperSpaceBetween
            }
        };
    }

    window.mainSwiper = new Swiper(containerId + '.product-media-main', mainSwiperOptions);

    $(containerId + '.product-media-main img').click(function(){
        window.mainSwiper.slideNext();
    });

    // Quantity.
    $(containerId + '.product-information-quantity button[name="minus"]').click(function(){
        if($('#product-information-cart-button').attr('disabled')){
            return;
        }

        var input = $(containerId + '.product-information-quantity-field');
        var span = $(containerId + '.product-information-quantity-input');
        var value = Math.max(1, parseInt(input.val()) - 1);
        span.text(value);
        input.val(value);

        if(value == 1){
            $(containerId + '.product-information-quantity button[name="minus"] svg path').css('stroke', 'var(--color-border)');
        }
    });
    $(containerId + '.product-information-quantity button[name="plus"]').click(function(){
        if($('#product-information-cart-button').attr('disabled')){
            return;
        }

        var input = $(containerId + '.product-information-quantity-field');
        var span = $(containerId + '.product-information-quantity-input');
        var value = parseInt(input.val()) + 1;

        if($(this)[0].hasAttribute('data-stock')){
            value = Math.min(value, $(this).attr('data-stock'));
        }

        span.text(value);
        input.val(value);

        $(containerId + '.product-information-quantity button[name="minus"] svg path').css('stroke', 'var(--color-text)');
    });

    // Variant.
    $(containerId + '.product-variant-select').change(setupSelectedVariant);
    $(containerId + '.product-variant-radio').change(setupSelectedVariant);

    $(containerId + '.product-information-variant-picker-button-variant-option').click(function(){
        var radio = $(this).find('.product-variant-radio');
        $(containerId + '.product-variant-radio[name="' + radio.attr('name') + '"]').removeAttr('checked');
        radio.attr('checked', true);
        
        setupSelectedVariant();
    });

    $(containerId + '.product-information-variant-picker-button-box').click(function(e){
        var variants = $(this).find('.product-information-variant-picker-button-variants');
        if(variants.css('display') == 'none'){
            variants.css('display', 'flex');
            $(this).find('svg').css('rotate', '90deg');
            return;
        }

        if(
            $(e.target).is('.product-information-variant-picker-button-variant label') || 
            $(e.target).is('.product-information-variant-picker-button-variant label *')
        ){
            variants.css('display', 'none');
            $(this).find('svg').css('rotate', '0deg');
        }
    });

    setupSelectedVariant();

    // Form.
    $('form:not(#ContactFooter)').submit(function(event){
        event.preventDefault();

        if($('#product-information-cart-button').attr('disabled')){
            return;
        }

        showLoadingIndicator();

        $.ajax({
            type: 'POST', 
            url: '/cart/add.js',
            dataType: 'json', 
            data: $(this).serialize(),
            success: function(data){
                loadCartData(function(data){
                    openCartDrawer();
                    createCartItems(data);

                    hideLoadingIndicator();

                    if($('.product-information-buy-buttons').attr('data-vanga-activated') == 'true' && window.Vanga){
                        window.Vanga.open();
                        setTimeout(function(){ 
                            window.Vanga.refresh();
                            window.Vanga.refreshPromotion();
                        }, 1000);
                    }
                });
            },
            error:function(response){
                hideLoadingIndicator();

                if(response && response.responseJSON && response.responseJSON.description){
                    alert(response.responseJSON.message + "\n\n" + response.responseJSON.description);
                }
                else{
                    alert('Es ist ein Fehler aufgetreten. Bitte versuches es noch einmal.');
                }
            }
        });
    });

    // Scroll to form button.
    $(containerId + '.product-information-scroll-to-form').click(productScrollToCartButton);

    // Sticky add to cart button.
    if($('#sticky-add-to-cart').length > 0){
        // Apply cart button
        if($('#product-information-cart-button').length > 0){
            $('#sticky-add-to-cart').attr('style', $('#product-information-cart-button').attr('style'));
            $('#sticky-add-to-cart').html($('#product-information-cart-button').html());
        }

        // Handle position
        if($('#sticky-add-to-cart').attr('data-position') == "top"){
            var top = 0;

            if(
                $('#shopify-section-header-menu').css('--header-position').includes('fixed') && 
                window.screen.width > 767
            ){
                top = $('#header').outerHeight();
            }

            $('#sticky-add-to-cart').css({
                bottom: 'initial',
                top: top
            });
        }

        // Setup click
        $('#sticky-add-to-cart').click(function(){
            if($(this).attr('data-action') == "scroll"){
                productScrollToCartButton();
            }
            else{
                $('#product-information-cart-button').click();
            }
        });

        // Handle scroll.
        setTimeout(function(){
            var scrollTopCartButton = 0;

            if($('#product-information-cart-button').length > 0){
                scrollTopCartButton = $('#product-information-cart-button').offset().top;
            }

            $(window).scroll(function(){
                if($(this).scrollTop() > scrollTopCartButton){
                    $('#sticky-add-to-cart').css('display', 'flex');
                }
                else{
                    $('#sticky-add-to-cart').hide();
                }
            });
        }, 100);
    }
}

function productScrollToCartButton(){
    var scrollTop = 0;

    if($('#product-information-cart-button').length > 0){
        scrollTop = $('#product-information-cart-button').offset().top - (window.screen.height / 2);
    }

    $('html, body').animate({
        scrollTop: scrollTop
    }, 500);
}

function setupSelectedVariant(){
    var options = [];
    $('.product-variant-select').each(function(){
        options.push({
            key: 'option' + (cr_product.options.indexOf($(this).attr('name')) + 1),
            value: $(this).val()
        });
    });

    $('.product-information-variant-picker-button-variant-option').removeClass('product-information-variant-picker-button-variant-option-checked');
    $('.product-variant-radio:checked').each(function(){
        $(this).parent().addClass('product-information-variant-picker-button-variant-option-checked');

        var span = $(this).parents('.product-information-variant-picker-button-variant').find('label span:eq(1)');
        if(span.attr('data-color-swatch') == "true"){
            span.html($(this).val() + '<span class="color-swatch" style="background-color: ' + $(this).next().css('background-color') + ';"></span>');

            $(this).parents('.product-information-variant-picker-button-variant').find('label span:eq(0) div').html(': ' + $(this).val());
        }
        else{
            span.html($(this).val());
        }

        options.push({
            key: 'option' + (cr_product.options.indexOf($(this).attr('name')) + 1),
            value: $(this).val()
        });
    });

    var selectedVariant = cr_product.variants.find(function(variant) {
        return options.every(function(values) {
            return variant[values.key] === values.value;
        });
    });

    // Disabled atc button when variant not exists.
    if(!selectedVariant){
        $('#product-information-cart-button').attr('disabled', true);
        $('.product-information-quantity').css('opacity', '0.4');
        $('#product-information-cart-button span').text($('#product-information-cart-button').attr('data-text-disabled'));

        return;
    }

    $('input[name="id"]').val(selectedVariant.id);

    // Handle inventory.
    $('#product-information-cart-button').removeAttr('disabled');
    $('.product-information-quantity').css('opacity', '1');
    $('#product-information-cart-button span').text($('#product-information-cart-button').attr('data-text-normal'));

    if(cr_variantStock.hasOwnProperty(selectedVariant.id)){
        $('.product-information-quantity button[name="plus"]').attr('data-stock', cr_variantStock[selectedVariant.id]);

        var input = $('.product-information-quantity-field');
        var value = parseInt(input.val());
        if(value > cr_variantStock[selectedVariant.id]){
            value = cr_variantStock[selectedVariant.id];
        }
        else if(value == 0 && cr_variantStock[selectedVariant.id] > 0){
            value = 1;
        }
        input.val(value);

        $('.product-information-quantity').each(function(){
            $(this).find('.product-information-quantity-input').text(value);
    
            if(value < 2){
                $(this).find('button[name="minus"] svg path').css('stroke', 'var(--color-border)');
            }
            else{
                $(this).find('button[name="minus"] svg path').css('stroke', 'var(--color-text)');
            }

            // Disable button.
            if(value == 0){
                $('#product-information-cart-button').attr('disabled', true);
                $('.product-information-quantity').css('opacity', '0.4');
                $('#product-information-cart-button span').text($('#product-information-cart-button').attr('data-text-disabled'));
            }
        });

        // Disable button.
        if($('.product-information-quantity').length == 0 && value == 0){
            $('#product-information-cart-button').attr('disabled', true);
            $('.product-information-quantity').css('opacity', '0.4');
            $('#product-information-cart-button span').text($('#product-information-cart-button').attr('data-text-disabled'));
        }
    }
    else{
        $('.product-information-quantity button[name="plus"]').removeAttr('data-stock');

        $('.product-information-quantity').each(function(){
            var input = $('.product-information-quantity-field');
            var value = parseInt(input.val());
            if(value != 0){
                return;
            }

            value = 1;
    
            $('.product-information-quantity-input').text(value);
            input.val(value);
    
            $('button[name="minus"] svg path').css('stroke', 'var(--color-border)');
        });
    }

    // Show weight.
    if($('.product-weight').length > 0 && cr_productWeight && cr_productWeight[selectedVariant.id]){
        $('.product-weight-value').html(cr_productWeight[selectedVariant.id]);
    }

    // Show price.
    PriceFormatter.showPrice('.product-information-price', selectedVariant.price, selectedVariant.compare_at_price);

    if(selectedVariant.featured_image && selectedVariant.featured_image.position && $('.variant-picker').data('selectVariantImage')){
        window.mainSwiper.slideTo(selectedVariant.featured_image.position - 1);
    }

    // Show unit price.
    if($('.product-information-unit-price').length > 0){
        if(selectedVariant.unit_price_measurement){
            $('.product-information-unit-price').show();

            PriceFormatter.showPrice('.product-information-unit-price-price', selectedVariant.unit_price);
            $('.product-information-unit-price-unit').text(selectedVariant.unit_price_measurement.reference_value + '' + selectedVariant.unit_price_measurement.reference_unit);
        }
        else{
            $('.product-information-unit-price').hide();
        }
    }

    // Handle price discount badge.
    if($('.product-information-price-saved').length == 0){
        return;
    }

    if(selectedVariant.compare_at_price > selectedVariant.price){
        $('.product-information-price-saved').show();
    }
    else{
        $('.product-information-price-saved').hide();
    }

    if($('.product-information-price-saved').attr('data-type') == 'percentage'){
        var value = (selectedVariant.compare_at_price - selectedVariant.price) * 100 / selectedVariant.compare_at_price;
        $('.product-information-price-saved span').html(Math.ceil(value) + '%');
    }
    else{
        PriceFormatter.showPrice('.product-information-price-saved span', selectedVariant.compare_at_price - selectedVariant.price);
    }
}

/* ==================================== */
/* =============== CART =============== */
/* ==================================== */

function initCart(){
    $('.cart-drawer-content').on('click', '.cart-drawer-item-quantity-minus', function(){
        var lineIndex = $(this).attr('data-line-index');
        var input = $('#cart-drawer-item-quantity-input-' + lineIndex);
        input.val(parseInt(input.val()) - 1);

        updateCartItemQuantity(lineIndex, input.val());
    });
    $('.cart-drawer-content').on('click', '.cart-drawer-item-quantity-plus', function(){
        var lineIndex = $(this).attr('data-line-index');
        var input = $('#cart-drawer-item-quantity-input-' + lineIndex);
        var value = parseInt(input.val()) + 1;

        if($(this)[0].hasAttribute('data-stock') && value > parseInt($(this).attr('data-stock'))){
            return;
        }

        input.val(value);

        updateCartItemQuantity(lineIndex, input.val());
    });
    $('.cart-drawer-content').on('click', '.cart-drawer-item-remove', function(){
        updateCartItemQuantity($(this).attr('data-line-index'), 0);
    });
}

function updateCartItemQuantity(line, quantity){
    showLoadingIndicator();

    $.ajax({
        type: 'POST', 
        url: '/cart/change',
        dataType: 'json', 
        data: {
            line: line,
            quantity: quantity
        },
        success: function(){
            loadCartData(function(data){
                createCartItems(data);

                hideLoadingIndicator();
            });
        },
        error:function(){
            alert('Es ist ein Fehler aufgetreten. Bitte versuches es noch einmal.');
        }
    });
}

function loadCartData(callback){
    $.ajax({
        type: 'GET', 
        url: '/cart.js',
        dataType: 'json', 
        success: function(data){
            if(callback){
                callback(data);
            }
        },
        error:function(){
            alert('Es ist ein Fehler aufgetreten. Bitte versuches es noch einmal.');
        }
    });
}

function createCartItems(cartData){
    var totalQuantity = 0;

    if(!cartData || !cartData.items || cartData.items.length == 0){
        $('.cart-drawer-empty').show();
        $('.cart-drawer-contents').hide();
        $('.cart-drawer-footer').hide();

        $('#header-cart-drawer-item-count').text(totalQuantity);
        $('#header-cart-drawer-item-count').hide();
        return;
    }

    $('.cart-drawer-empty').hide();
    $('.cart-drawer-contents').show();
    $('.cart-drawer-footer').show();

    $('.cart-drawer-item').not('.cart-drawer-item-temp').remove();

    $('.cart-drawer-items').each(function(parentIndex, parent){
        cartData.items.forEach(function(item, index){
            var element = $(parent).find('.cart-drawer-item-temp').clone();
            element.appendTo($(parent));
            element.removeClass('cart-drawer-item-temp');
            element.show();

            element.find('.cart-drawer-item-image').attr('src', item.image);
            
            var data = element.find('.cart-drawer-item-data');
            data.find('h3').text(item.product_title);

            // Info text
            if(element.find('.cart-drawer-item-option-info').length > 0){
                var infoTextMetaField = element.find('.cart-drawer-item-option-info').attr('data-info-text-metafield').trim();
                if(infoTextMetaField == 'true'){
                    try{
                        element.find('.cart-drawer-item-option-info').text(cr_products_info_text_metafields[item.product_id]);
                    } catch (error) {

                    }
                }
            }

            // Options
            if(!item.product_has_only_default_variant){
                var options = data.find('.cart-drawer-item-options');

                item.options_with_values.forEach(function(option){
                    options.append(
                        '<div class="cart-drawer-item-option"><span>' + option.name + ':</span> ' + option.value + '</div>'
                    );
                });
            }

            // Properties
            if(item.properties && Object.keys(item.properties).length > 0){
                var properties = data.find('.cart-drawer-item-properties');

                for(var key in item.properties){
                    if(item.properties.hasOwnProperty(key)){
                        var value = item.properties[key];

                        if(value.indexOf('/uploads/') !== -1){
                            var brackets = value.split('/');
                            value = '<a href="' + value + '" target="_blank">' + brackets[brackets.length - 1] + '</a>';
                        }

                        properties.append(
                            '<div class="cart-drawer-item-option"><span>' + key + ':</span> ' + value + '</div>'
                        );
                    }
                }
            }

            // Price
            var variant = cr_product.variants.find(v => v.id == item.variant_id);

            if(variant && variant.compare_at_price != item.final_line_price){
                PriceFormatter.showPriceByElement(data.find('.cart-drawer-item-price'), item.final_line_price, variant.compare_at_price * item.quantity);
            }
            else{
                PriceFormatter.showPriceByElement(data.find('.cart-drawer-item-price'), item.original_line_price);
            }

            // Quantity + Remove
            data.find('.cart-drawer-item-quantity-minus').attr('data-line-index', index + 1);
            data.find('.cart-drawer-item-quantity-plus').attr('data-line-index', index + 1);
            data.find('.cart-drawer-item-remove').attr('data-line-index', index + 1);

            data.find('.cart-drawer-item-quantity input').attr('id', 'cart-drawer-item-quantity-input-' + String(index + 1));
            data.find('.cart-drawer-item-quantity input').val(item.quantity);

            totalQuantity += item.quantity;
        });
    });

    // Cart drawer footer.
    PriceFormatter.showPrice('.cart-drawer-footer-subtotal', cartData.items_subtotal_price);
    PriceFormatter.showPrice('.cart-drawer-footer-total', cartData.total_price + parseInt($('.cart-drawer-footer').attr('data-delivery-costs')));

    // Header.
    $('#header-cart-drawer-item-count').text(totalQuantity);
    
    if(parseInt(totalQuantity) > 0){
        $('#header-cart-drawer-item-count').show();
        $('#header-cart-drawer-item-count').removeClass('hide');
    }
    else{
        $('#header-cart-drawer-item-count').hide();
    }

    // Shipping bar.
    var freeShippingOrderValue = parseInt($('.cart-drawer-footer').attr('data-free-shipping-order-value'));
    var ceilPricesForFreeShipping = $('.cart-drawer-footer').attr('data-ceil-product-prices') == 'true' ? true : false;
    var total = 0;

    cartData.items.forEach(function(item, index){
        if(ceilPricesForFreeShipping){
            total += Math.ceil(item.final_line_price / 1000) * 1000;
        }
        else{
            total += item.final_line_price;
        }
    });

    if(freeShippingOrderValue > 0){
        $('.cart-drawer-footer-free-shipping .free').hide();
        $('.cart-drawer-footer-free-shipping .price').hide();

        if(freeShippingOrderValue <= total){
            $('.cart-drawer-footer-free-shipping .free').show();
            $('.cart-drawer-footer-free-shipping').removeClass('cart-drawer-footer-free-shipping-costs');
            $('.cart-drawer-footer-free-shipping').css('color', $('.cart-drawer-footer-free-shipping').attr('data-free-color'));

            PriceFormatter.showPrice('.cart-drawer-footer-total', cartData.total_price);
        }
        else{
            $('.cart-drawer-footer-free-shipping .price').show();
            $('.cart-drawer-footer-free-shipping').addClass('cart-drawer-footer-free-shipping-costs');
            $('.cart-drawer-footer-free-shipping').css('color', 'var(--color-text)');
        }
    }

    if($('.cart-drawer-footer-free-shipping-container').length > 0){
        if(total >= freeShippingOrderValue){
            $('.cart-drawer-footer-free-shipping-container').hide();
        }
        else{
            $('.cart-drawer-footer-free-shipping-container').show();

            PriceFormatter.showPrice('.cart-drawer-footer-free-shipping-container h4', freeShippingOrderValue - total);

            var percentage = total / freeShippingOrderValue * 100;

            $('.cart-drawer-footer-free-shipping-bar-status').css('width', percentage + '%');
            $('.cart-drawer-footer-free-shipping-bar-point').css('left', percentage + '%');
        }
    }
}

/* ========================================== */
/* =============== COLLECTION =============== */
/* ========================================== */

function handleCollectionPage(){
    var currentPage = 1;
    var allowFetchPages = true;
    var isLoading = false;

    $(window).scroll(function(){
        if(!allowFetchPages || isLoading){
            return;
        }

        var scrollPosition = $(window).scrollTop() + window.screen.height * 1.3;
        var gridBottom = $('.collection-product-grid').offset().top + $('.collection-product-grid').height();

        if(scrollPosition < gridBottom){
            return;
        }

        currentPage++;
        isLoading = true;

        $('.collection-product-grid-loading').show();

        $.ajax({ 
            url: '?page=' + currentPage,
            success: function(data){
                $('.collection-product-grid-loading').hide();
                isLoading = false;

                if(!data){
                    return;
                }

                var html = $(data);
                if(html.find('.card-product').length > 0){
                    $('.collection-product-grid-cards').append(html.find('.collection-product-grid-cards').html());
                    return;
                }

                allowFetchPages = false;
            },
            error:function(){
                $('.collection-product-grid-loading').hide();
                isLoading = false;
            }
        });
    });
}

/* ======================================== */
/* =============== SECTIONS =============== */
/* ======================================== */

function handleSections(containerId){
    if(containerId){
        containerId = '#' + containerId + ' ';
    }
    else{
        containerId = "";
    }

    // Collapsible Content.
    $(containerId + '.collapsible-content-row-header').click(function(){
        $(this).find('svg').css('rotate', '90deg');
        $(this).find('h3 span:last-child').text('-');
        $(this).next().toggle();

        if($(this).next().css('display') == 'none'){
            $(this).find('svg').css('rotate', '0deg');
            $(this).find('h3 span:last-child').text('+');
        }
    });

    // Collection
    $(containerId + '.section-collection-cards').each(function(){
        if($(this).attr('data-use-slider') != "true"){
            return true;
        }

        var config = {
            slidesPerView: parseFloat($(this).attr('data-product-count-mobile')),
            spaceBetween: 20,
            grabCursor: true,
            breakpoints: {
                768: {
                    slidesPerView: parseFloat($(this).attr('data-product-count-desktop'))
                }
            }
        };

        if($(this).attr('data-show-navigation') == "true" && $(this).attr('data-use-slider') == "true"){
            config.navigation = {
                nextEl: $(this).find('.swiper-button-next')[0],
                prevEl: $(this).find('.swiper-button-prev')[0]
            };
        }

        new Swiper($(this)[0], config);
    });

    // Custom reviews
    new Swiper(containerId + ".custom-reviews-cards",{
        loop: true,
        navigation: {
            nextEl: containerId + '.custom-reviews-cards .swiper-button-next',
            prevEl: containerId + '.custom-reviews-cards .swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 20
            }
        }
    });

    // Video Banner
    $(containerId + '.video-banner').each(function(){
        if($(this).find('video').length == 0){
            return;
        }

        videoBannerVideoLoaded($(this), $(this).find('video'));
    });

    // Selling point slider
    $(containerId + '.selling-point-slider').each(function(){
        new Swiper($(this)[0], {
            slidesPerView: 1,
            centeredSlides: true,
            loop: true,
            autoplay:{
                delay: parseInt($(this).attr('data-slideshow-speed')) * 1000,
                disableOnInteraction: false
            },
            breakpoints: {
                768: {
                    centeredSlides: false,
                    slidesPerView: parseInt($(this).attr('data-desktop-slides-per-view'))
                }
            }
        });
    });    
}

function videoBannerVideoLoaded(videoBanner, video){
    if(video[0].readyState != 4){
        setTimeout(function(){
            videoBannerVideoLoaded(videoBanner, video);
        }, 50);
        return;
    }

    videoBanner.css('padding-bottom', (video.height() / video.width() * 100) + '%');
}